import { render, staticRenderFns } from "./TimelineAddItemDialog.vue?vue&type=template&id=0f19e56a&scoped=true"
import script from "./TimelineAddItemDialog.vue?vue&type=script&lang=ts"
export * from "./TimelineAddItemDialog.vue?vue&type=script&lang=ts"
import style0 from "./TimelineAddItemDialog.vue?vue&type=style&index=0&id=0f19e56a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f19e56a",
  null
  
)

export default component.exports